module.exports = __webpack_public_path__ + "static/media/icon-make-sales.d2ba20aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/icon-make-sales.svg
// module id = 2940
// module chunks = 0